import { ReactNode, createContext, useContext } from 'react'

import { useMediaQuery } from 'usehooks-ts'

type ContainerType = 'fluid' | 'fixed'

interface ContainerContextProps {
  containerType: ContainerType
}

const ContainerContext = createContext<ContainerContextProps | undefined>(
  undefined
)

export const ContainerProvider = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery('(max-width: 992px)')
  const containerType: ContainerType = isMobile ? 'fluid' : 'fixed'

  return (
    <ContainerContext.Provider value={{ containerType }}>
      {children}
    </ContainerContext.Provider>
  )
}

export const useContainer = () => {
  const context = useContext(ContainerContext)
  if (!context) {
    throw new Error('useContainer must be used within a ContainerProvider')
  }
  return context
}
